"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorHash = void 0;
var color_hash_1 = require("./color.hash");
Object.defineProperty(exports, "ColorHash", { enumerable: true, get: function () { return color_hash_1.ColorHash; } });
//# sourceMappingURL=index.js.map